export const getVueAppBaseApi = () => {
  return process.env.VUE_APP_BASE_API;
};

export const getVueAppUploadApi = () => {
  return process.env.VUE_APP_UPLOAD_API;
};
